import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';

import CancelButton from '../../components/psc/lib/CancelButton'
import SaveButton from '../../components/psc/lib/SaveButton'
import ErrorMessage from '../../components/psc/lib/ErrorMessage'
import useCadmObject from '../../hooks/useCadmObject'
import useBrowserTabTitle from '../../hooks/useBrowserTabTitle'
import TextArea from '../../components/psc/lib/TextArea'

const CadmObject = () => {
    let { objID } = useParams()
    const isNew = objID === "new" ? true : false
    objID = parseInt(objID,10)
    const objectUrl = '/v0/cadm_objects' + (isNew ? '' : '/' + objID)

    // Fields
    const [name, setName] = useState('')

    useBrowserTabTitle(isNew ? 'New Configured Item' : (name || 'Configured Item'))
    const [description, setDescription] = useState('')

    // Read-only
    const [customFields, setCustomFields] = useState([])
    const [isUsed, setIsUsed] = useState(false)

    // Submit
    const [submitActive, setSubmitActive] = useState(false)
    const [error, setError] = useState(null)

    useEffect(() => {
        if ( ! isNew) {
            fetchObject()
        }
    }, [isNew])

    const fetchObject = () => {
        fetch(objectUrl, { credentials: 'same-origin' })
            .then(function(response) {
                if (response.ok) {
                    return response.json()
                } else {
                    throw new Error(response.statusText)
                }
            })
            .then(function(json) {
                if(json.error) {
                    throw new Error(json.error)
                }

                fromBackend(json.result)
            })
            .catch(function(error) {
                console.log(error)
            })
    }

    const fromBackend = (obj) => {
        setName(obj.name)
        setDescription(obj.description)
        setIsUsed(obj.is_used)
        setCustomFields(obj.custom_fields)
    }

    const toBackend = () => {
        return {
            name: name.trim(),
            description: description.trim(),
        }
    }

    const validateBeforeSubmit = () => {
        let errors = []

        if ( ! name ) {
            errors.push('Name is required')
        }

        if ( errors.length > 0 ) {
            setError(errors)
            return false
        }

        return true
    }

    const handleSubmitError = (props) => {
        setSubmitActive(false)
        setError([ props.message ])
    }
    
    const handleSubmit = (event) => {
        if( event ) {
            event.preventDefault()
        }
        if( submitActive || !validateBeforeSubmit() ) {
            return null
        }

        setSubmitActive(true)

        return {
            objType: 'cadm_objects',
            objID: objID,
            data: toBackend(),
        }
    }

    let requiredIndicator = (<label className="form-required-star">&nbsp;*</label>);

    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h2>Model: {name || '<New Model>'}</h2>
                        </div>
                        <div className="ibox-content">
                            <form className="form-horizontal" onSubmit={(e) => handleSubmit(e)}>
                                <div className="form-group">
                                    <label className="col-sm-2 control-label">Name
                                        {requiredIndicator}
                                    </label>
                                    <div className="col-sm-8">
                                        <input className="form-control" type="text"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            required 
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="col-sm-2 control-label">Description</label>
                                    <div className="col-sm-8">
                                        <TextArea 
                                            className="form-control" 
                                            name="description" 
                                            value={description} 
                                            onChange={e => setDescription(e.target.value)}  
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="col-sm-2 control-label">Custom Fields</label>
                                    <div className="col-sm-8">
                                        <ul className="list-group clear-list">
                                            {customFields.map(function(field) {
                                                return <li className="list-group-item" key={field.id}>{field.name}</li>
                                            })}
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="hr-line-dashed"></div>
                                
                                <div className="form-group">
                                    <ErrorMessage
                                        error={error}
                                    />

                                    <div className="col-sm-10 col-sm-offset-2">
                                        <CancelButton />
                                        
                                        <SaveButton
                                            buttonVariant='primary'
                                            visible={true}
                                            spinnerActive={submitActive}
                                            label='Save Changes'
                                            onClick={handleSubmit}
                                            onError={handleSubmitError}
                                        />

                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default CadmObject
